import { render, staticRenderFns } from "./PointsTable.vue?vue&type=template&id=ddf08e50&scoped=true"
import script from "./PointsTable.vue?vue&type=script&lang=js"
export * from "./PointsTable.vue?vue&type=script&lang=js"
import style0 from "./PointsTable.vue?vue&type=style&index=0&id=ddf08e50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf08e50",
  null
  
)

export default component.exports